module.exports = __webpack_public_path__ + "static/media/bfm.703cc0d1.png";